import React from 'react';

const IconPerformio = () => (
  <svg
    version="1.1"
    width="100%"
    viewBox="0 0 95.0 96.0"
    style={{
      width: '100%',
    }}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="IconPerformio-i0">
        <path d="M70,0 C82.7025492,-2.33342044e-15 93,10.2974508 93,23 L93,71 C93,83.7025492 82.7025492,94 70,94 L23,94 C10.2974508,94 1.55561363e-15,83.7025492 0,71 L0,23 C-1.55561363e-15,10.2974508 10.2974508,-1.21929324e-15 23,0 L70,0 Z" />
      </clipPath>
      <clipPath id="IconPerformio-i1">
        <path d="M34.2057403,0.0844138636 C39.5604578,0.443802998 44.5991296,1.91928502 49.1574119,4.74021882 C54.9563994,8.33049821 59.2600391,13.2860951 61.4795831,19.7876071 C64.9922055,30.0780558 63.4715741,39.6786218 56.7804347,48.2714534 C52.5959893,53.6478426 47.0227488,57.0683603 40.4074604,58.7768132 C37.256033,59.5895022 34.0576504,60.0753096 30.8105063,59.9904287 C27.9408112,59.9163837 25.0891758,59.5461588 22.1075102,58.6142754 C24.7478464,53.2198264 27.3448392,47.9120643 29.9346082,42.616944 C32.903632,42.9600793 35.6288491,42.5374811 38.1012296,40.9428046 C41.0883132,39.0158287 42.7480047,36.1967009 43.3385587,32.7689593 C44.1512477,28.0445273 43.1218416,23.7733951 39.5821296,20.3908029 C36.9092857,17.8389595 33.6639477,16.8781805 29.9346082,17.3495401 C24.8020257,17.9978853 21.7950764,21.0174764 20.2347135,25.7094009 C19.8897722,26.7478368 19.7759957,27.8856014 19.6983388,28.9854405 C19.6495774,29.6807411 19.4762038,30.0347123 18.7736793,30.2604593 C15.6457296,31.2663877 12.5430637,32.349973 9.42414389,33.384797 C6.73143434,34.2787549 4.02066505,35.1221455 1.33517941,36.0359691 C0.764491136,36.2292085 0.58028163,36.1100141 0.486370902,35.5591915 C-0.31187029,30.8943567 -0.158362369,26.2818952 1.17625356,21.7218069 C2.43321254,17.430809 4.56787564,13.6400663 7.57301895,10.3315191 C10.7732076,6.80806083 14.5693682,4.18578433 19.0066501,2.4231522 C23.9080678,0.476310557 28.9647993,-0.267751368 34.2057403,0.0844138636 Z" />
      </clipPath>
      <clipPath id="IconPerformio-i2">
        <path d="M29.3109831,0 L29.5078345,0.216717066 C28.7619666,1.74818433 28.0197106,3.28145757 27.2702308,4.81111886 C24.7797905,9.896746 22.2857383,14.9805672 19.793492,20.0661943 L18.2839222,23.1304833 C17.7820867,24.1526655 17.284992,25.1771051 16.8027965,26.2083171 C16.5084225,26.8367966 16.102078,26.9198715 15.583763,26.6525871 C12.2210365,24.9134327 9.06780322,22.8744863 6.42385502,20.1294035 C3.77990682,17.3825146 1.71928872,14.250953 0.27992621,10.7148529 C0.211299139,10.5487032 0.155313897,10.3771355 0.102940606,10.2037618 C0.0686270708,10.0917914 0.0523732909,9.97440295 0,9.7269843 C9.77755161,6.48164624 19.5442674,3.24172611 29.3109831,0 Z" />
      </clipPath>
    </defs>
    <g transform="translate(1.0 1.0)">
      <g clipPath="url(#IconPerformio-i0)">
        <polygon
          points="0,0 93,0 93,94 0,94 0,0"
          stroke="none"
          fill="#3F44FF"
        />
      </g>
      <path
        d="M23,0 L70,0 C82.7025492,-2.33342044e-15 93,10.2974508 93,23 L93,71 C93,83.7025492 82.7025492,94 70,94 L23,94 C10.2974508,94 1.55561363e-15,83.7025492 0,71 L0,23 C-1.55561363e-15,10.2974508 10.2974508,-1.21929324e-15 23,0 Z"
        stroke="#EAEFFF"
        strokeWidth="1"
        fill="none"
        strokeMiterlimit="10"
      />
      <g transform="translate(14.99999999999999 17.0)">
        <g clipPath="url(#IconPerformio-i1)">
          <polygon
            points="5.55111512e-17,-4.4408921e-16 63.3123424,-4.4408921e-16 63.3123424,60 5.55111512e-17,60 5.55111512e-17,-4.4408921e-16"
            stroke="none"
            fill="#FFFFFF"
          />
        </g>
        <g transform="translate(1.8119569533824027 30.381459646209336)">
          <g clipPath="url(#IconPerformio-i2)">
            <polygon
              points="0,0 29.5078345,0 29.5078345,26.7961223 0,26.7961223 0,0"
              stroke="none"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default IconPerformio;
